"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyMenuConfigurationNodesTooltip = void 0;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SankeyMenuConfigurationNodesTooltip = (t, data, set_data, multi_selected_nodes) => {
    return (react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: "node_tooltip", title: t('Noeud.IB') },
        react_1.default.createElement(react_bootstrap_1.Form, null,
            react_1.default.createElement(react_bootstrap_1.Row, null,
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 12 },
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Noeud.tooltips.IB.1', placement: 'top', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Noeud.tooltips.IB.1' },
                            t('Noeud.tooltips.IB'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 10, value: multi_selected_nodes.current.length > 0 && multi_selected_nodes.current[0].tooltip_text ? multi_selected_nodes.current[0].tooltip_text : '', onChange: (evt) => {
                                multi_selected_nodes.current.map(node => node.tooltip_text = evt.target.value);
                                set_data(Object.assign({}, data));
                            } })))))));
};
exports.SankeyMenuConfigurationNodesTooltip = SankeyMenuConfigurationNodesTooltip;
